import { cn } from "@/lib/utils";

export function getSharedNavigationStyles(selected: boolean, isMobile = false) {
    const baseStyles = "transition-all duration-200 ease-in-out";
    const selectedStyles = cn(
        "text-blue-800 border border-blue-300 shadow-sm hover:bg-blue-100 hover:text-blue-900 dark:text-slate-100 dark:border-slate-500 dark:hover:bg-slate-800 dark:hover:text-slate-50 transition-all duration-200 ease-in-out",
        isMobile ? "bg-blue-100/80 dark:bg-slate-800" : "bg-transparent"
    );
    const hoverStyles = "hover:bg-gray-50 dark:hover:bg-slate-800";

    return cn(baseStyles, selected ? selectedStyles : hoverStyles);
}

export function checkIfSelected(routeName: string, currentPath = window.location.pathname) {
    const routePath = routeName.split("?")[0];
    if (!routePath || routePath === "/") {
        return currentPath === "/" || currentPath === "";
    }

    const section = navSectionRoot(routePath);
    if (section && (currentPath === section || currentPath.startsWith(`${section}/`))) {
        return true;
    }

    return currentPath === routePath || currentPath.startsWith(`${routePath}/`);
}

function navSectionRoot(routePath: string): string | null {
    if (routePath === "/customers" || routePath.startsWith("/customers/")) return "/customers";
    if (routePath === "/sales" || routePath.startsWith("/sales/")) return "/sales";
    return null;
}

export function showNotificationCount(routeName: string) {
    return routeName.startsWith("/diaries");
}

export function showWorklistNotificationCount(routeName: string) {
    return routeName.startsWith("/worklist");
}

export function showProfileNotificationCount(routeName: string) {
    return routeName.startsWith("/profile");
}

export function showValidationNotificationCount(routeName: string) {
    return routeName.startsWith("/validate");
}
